import React, { Component } from 'react';
import './upcomingEvent.scss';
import ReactDOM from 'react-dom';
import UpcomingEventGIF from '../../static/images/promo.gif'

export default class UpcomingEvent extends Component {
    constructor(props) {
        super(props);
        // Use state to track if the modal is open
        this.state = {
            isModalOpen: true
        };
    }

    // Toggle function
    toggleModal = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    }

    // Handle clicking the dark backdrop
    handleBackdropClick = (e) => {
        // Only close if the user clicked the overlay itself, not the content inside
        if (e.target.id === "modalOverlay") {
            this.toggleModal();
        }
    }

    render() {
        const { isModalOpen } = this.state;

        if (!isModalOpen) return <></>;

        // createPortal renders this HTML directly into the document body
        return ReactDOM.createPortal(
            <div id="modalOverlay" className="modal-overlay" onClick={this.handleBackdropClick}>
                <div className="modal-content">
                    <span className="close-btn" onClick={this.toggleModal}>&times;</span>
                    <img src={UpcomingEventGIF} alt="Upcoming" />
                </div>
            </div>,
            document.body // This sends the modal to the very end of the HTML body
        );
    }
}